import axios from "axios";

export function sendGroupMessageWs(qData, getState) {
  const state = getState();
  const jwtToken = state.authData[0].signInUserSession.accessToken.jwtToken;

  const headers = {
    Authorization: `Bearer ${jwtToken}`,
  };

  return axios
    .put(
      `${process.env.REACT_APP_API_URL}/${process.env.REACT_APP_ENV}/sendGroupNotifs`,
      qData,
      { headers }
    )
    .then((res) => {
      return res;
    })
    .catch((err) => {
      throw err;
    });
}
